const installationSubcategories = [
  { key: 'Profesional', label: 'Profesional' },
  { key: 'Doméstico', label: 'Doméstico' },
  { key: 'Reinstalación', label: 'Reinstalación' },
  { key: 'Miele', label: 'Miele' }
]
const maintenanceSubcategories = [
  { key: 'Mantenimiento Regular', label: 'Mantenimiento Regular' },
  { key: 'Certificado de servicio doméstico', label: 'Certificado de servicio doméstico' },
  { key: 'Certificado de mantenimiento Profesional', label: 'Certificado de mantenimiento Profesional' },
  { key: 'Certificado de mantenimiento Doméstico', label: 'Certificado de mantenimiento Doméstico' },
  { key: 'Miele', label: 'Miele' }
]

const repairSubcategories = [
  { key: 'Profesional', label: 'Profesional' },
  { key: 'Doméstico', label: 'Doméstico' },
  { key: 'Garantía de reparación previa - Profesional', label: 'Garantía de reparación previa - Profesional' },
  { key: 'Garantía de reparación previa - Doméstico', label: 'Garantía de reparación previa - Doméstico' },
  { key: 'Garantía de Manufactura', label: 'Garantía de Manufactura' },
  { key: 'Garantía de instalación - Profesional', label: 'Garantía de instalación - Profesional' },
  { key: 'Garantía de instalación - Doméstico', label: 'Garantía de instalación - Doméstico' },
  { key: 'Cortesía - Cargo a ventas Profesional', label: 'Cortesía - Cargo a ventas Profesional' },
  { key: 'Cortesía - Cargo a ventas Doméstico', label: 'Cortesía - Cargo a ventas Doméstico' },
  { key: 'Cortesía - Cargo a Servicio', label: 'Cortesía - Cargo a Servicio' },
  { key: 'Diagnóstico', label: 'Diagnóstico' },
  { key: 'Miele', label: 'Miele' }
]

const fallbackSubcategories = [
  { key: 'Ninguna', label: 'Ninguna' },
  { key: 'Miele', label: 'Miele' }
]

export { installationSubcategories, maintenanceSubcategories, repairSubcategories, fallbackSubcategories }
